var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex" }, [
    _c(
      "div",
      { class: ["audio-player", _vm.secondaryStyle ? "secondary" : "primary"] },
      [
        _c(
          "button",
          { staticClass: "play-pause-button", on: { click: _vm.togglePlay } },
          [
            _vm.isPlaying
              ? _c("b-icon-pause-fill", { staticClass: "icon" })
              : _c("b-icon-play-fill", { staticClass: "icon" })
          ],
          1
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.progress,
              expression: "progress"
            }
          ],
          staticClass: "audio-bar",
          attrs: { type: "range", max: "100" },
          domProps: { value: _vm.progress },
          on: {
            input: _vm.seekAudio,
            __r: function($event) {
              _vm.progress = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm._f("formatTime")(_vm.currentTime)))])
      ]
    ),
    _vm._v(" "),
    _c(
      "audio",
      {
        ref: "audio",
        attrs: { preload: "auto" },
        on: { timeupdate: _vm.updateProgress, loadedmetadata: _vm.setDuration }
      },
      [_c("source", { attrs: { src: _vm.src, type: "audio/mpeg" } })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e04dad0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e04dad0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/AudioPlayer.vue
// module id = 3961
// module chunks = 14